import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Router, ActivatedRoute } from '@angular/router';
const routes: Routes = [ 
  { path: '', redirectTo: '/', pathMatch: 'full' },
  {
    path: '/', 
    loadChildren: () => import('./headquarter/headquarter.module').then(m => m.HeadquarterModule)
  },


];
 
@NgModule({
  //imports: [RouterModule.forRoot(routes, {onSameUrlNavigation: 'reload'})],
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { 
  
  constructor(private route: ActivatedRoute, private router: Router) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }


}
